import { render } from "./client-distribution-history.vue?vue&type=template&id=5e127682"
import script from "./client-distribution-history.vue?vue&type=script&lang=js"
export * from "./client-distribution-history.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__